/**
 * Josephine & June · member price in the search window (live check 2026-10-19, us-visitor #4).
 *
 * The header search window (predictive search) renders product cards through the theme's own
 * resource card, which has no jj price hook: a Vault piece read "$164.95 $0.00" with no member line,
 * which looks like a 100% markdown open to anyone. Product grids already show
 * "FREE ~~$164.95~~ for June Club members" (snippets/jj-vault-price.liquid); this script gives the
 * search window the same reading: every price that is exactly $0 becomes "FREE" and the card gets
 * the line "for June Club members". Paid pieces are left alone.
 *
 * Loaded as a module by snippets/jj-vip-config.liquid. No theme files outside the jj layer change.
 */

const NOTE = 'for June Club members';
const ZERO = /^\s*\$\s*0(?:\.00)?\s*(?:USD)?\s*$/i;

function fixCard(card) {
  if (!card || card.dataset.jjFree === '1') return;
  const prices = card.querySelectorAll('.price');
  let isFree = false;
  prices.forEach((el) => {
    if (ZERO.test(el.textContent || '')) {
      el.textContent = 'FREE';
      isFree = true;
    }
  });
  if (!isFree) return;
  card.dataset.jjFree = '1';
  const content = card.querySelector('.resource-card__content') || card;
  const note = document.createElement('p');
  note.className = 'jj-search-note';
  note.textContent = NOTE;
  note.style.cssText = 'margin:2px 0 0;font-size:0.8125rem;line-height:1.35;color:#6b6760;';
  content.appendChild(note);
}

function scan(root) {
  root.querySelectorAll('.resource-card').forEach(fixCard);
}

function watch(host) {
  scan(host);
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan(host);
    });
  }).observe(host, { childList: true, subtree: true });
}

function init() {
  const hosts = document.querySelectorAll('predictive-search-component');
  hosts.forEach(watch);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}

/*
 * Stale search index guard (19-10-2026). Shopify's search index still returns some archived
 * Nord Schmuck products, whose product pages are 404. On the search results page and in the
 * search window we check each product card once against /products/<handle>.js and hide the card
 * when that page does not exist, so visitors only ever see live Josephine & June pieces.
 * Remove this block once the archived products are deleted or the index has caught up.
 */
const checked = new Map();
function productExists(handle) {
  if (!checked.has(handle)) {
    checked.set(handle, fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
      .then((r) => r.ok).catch(() => true));
  }
  return checked.get(handle);
}
function guardLinks(root) {
  root.querySelectorAll('a[href*="/products/"]').forEach((a) => {
    const m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!m) return;
    const card = a.closest('product-card, li, .resource-card, .predictive-search__list-item') || a;
    if (card.dataset.jjChecked === '1') return;
    card.dataset.jjChecked = '1';
    productExists(m[1]).then((ok) => { if (!ok) card.style.display = 'none'; });
  });
}
function initGuard() {
  if (location.pathname.startsWith('/search')) guardLinks(document);
  document.querySelectorAll('predictive-search-component').forEach((host) => {
    new MutationObserver(() => guardLinks(host)).observe(host, { childList: true, subtree: true });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGuard, { once: true });
} else {
  initGuard();
}
